import { useTranslation } from "react-i18next";

export interface BNotAuthorizedProps {}

export const BNotAuthorized = () => {
  const { t } = useTranslation();

  return <div>{t("YOU_ARE_NOT_AUTHORIZED_TO_BE_HERE")}</div>;
};
